import { useQuery } from "@tanstack/react-query";
import { Dayjs } from "dayjs";

import {
  IFitbitActivityResponse,
  IFitbitSleepResponse,
} from "../../@types/Fitbit";
import { fitbitService } from "../../services/fitbitService";

export function useFitbitActivity(
  patientId: number,
  fromDate: Dayjs,
  toDate: Dayjs,
  enabled = true
) {
  const { data, isError, isFetching, isInitialLoading, refetch, isRefetching } =
    useQuery<IFitbitActivityResponse | undefined>({
      queryKey: [
        "fitbit-activity",
        patientId,
        fromDate.valueOf(),
        toDate.valueOf(),
      ],
      queryFn: async () => {
        const data = await fitbitService.getPatientActivityData(
          patientId,
          fromDate,
          toDate
        );
        return data;
      },
      enabled: enabled && patientId > 0,
    });

  return {
    activityData: data,
    isActivityFetching: isFetching,
    isActivityInitialLoading: isInitialLoading,
    isActivityError: isError,
    activityRefetch: refetch,
    isActivityRefetching: isRefetching,
  };
}

export function useFitbitSleep(
  patientId: number,
  fromDate: Dayjs,
  toDate: Dayjs,
  enabled = true
) {
  const { data, isError, isFetching, isInitialLoading, refetch, isRefetching } =
    useQuery<IFitbitSleepResponse | undefined>({
      queryKey: [
        "fitbit-sleep",
        patientId,
        fromDate.valueOf(),
        toDate.valueOf(),
      ],
      queryFn: async () =>
        fitbitService.getPatientSleepData(patientId, fromDate, toDate),
      enabled: enabled && patientId > 0,
    });

  return {
    sleepData: data,
    isSleepFetching: isFetching,
    isSleepInitialLoading: isInitialLoading,
    isSleepError: isError,
    sleepRefetch: refetch,
    isSleepRefetching: isRefetching,
  };
}
